module.exports = __webpack_public_path__ + "static/favicon-c974ff746047c350e542aee152659d6c.ico";